export const NotificationAction = Object.freeze({
  Delete: 1,
  Undelete: 2,
  Read: 3,
  Unread: 4,
  Flag: 5,
  Unflag: 6,
  Complete: 7,
  Incomplete: 8
});
